module.exports = __webpack_public_path__ + "static/media/ico-membership.d24678bc.svg";